var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40.5 20.333H25.192C23.688 16.062 19.618 13 14.833 13c-6.068 0-11 4.932-11 11s4.932 11 11 11c4.785 0 8.855-3.062 10.359-7.333h.641l3.667 3.666 3.667-3.666 3.666 3.666 7.334-7.406zM14.833 29.5c-3.025 0-5.5-2.475-5.5-5.5s2.475-5.5 5.5-5.5 5.5 2.475 5.5 5.5-2.475 5.5-5.5 5.5"
  }))));
};
export default SvgKey;